import YouMayAlsoLike from './YouMayAlsoLike'

export default YouMayAlsoLike
